import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useSaleRegionList() {
  // Use toast
  const toast = useToast()

  const refSaleRegionListTable = ref(null)

  const perPage = ref(5)
  const totalSaleRegions = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const branchFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refSaleRegionListTable.value ? refSaleRegionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSaleRegions.value,
    }
  })

  const refetchData = () => {
    refSaleRegionListTable.value.refresh()
  }

  watch([currentPage, perPage, branchFilter], () => {
    refetchData()
  })

  const fetchSaleRegions = (ctx, callback) => {
    store
      .dispatch('sale-region/fetchAll', {
        q: searchQuery.value,
        per_page: perPage.value,
        page: currentPage.value,
        sort_by: sortBy.value,
        sort_desc: isSortDirDesc.value,
        branch_id: branchFilter.value,
      })
      .then(response => {
        const { sale_regions, total } = response.data.data

        callback(sale_regions)
        totalSaleRegions.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error getting sale regions list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchSaleRegions,
    perPage,
    currentPage,
    totalSaleRegions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSaleRegionListTable,

    refetchData,

    // Filters
    branchFilter,

  }
}
